@if (breadcrumbs$ | async; as breadcrumbs) {
    <section>
        <app-breadcrumb [breadcrumbs]="breadcrumbs" />
    </section>
}
<section>
    <app-products-categories [currentPage]="'category'"></app-products-categories>
</section>

@if (category$ | async; as category) {
    <section>
        <app-products-listing [category]="category" />
    </section>
}

@if ((category$ | async) === null) {
    <div class="py-10">
        <div class="spinner mx-auto"></div>
    </div>
}
